import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=28240f52&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
import style0 from "./notification.vue?vue&type=style&index=0&id=28240f52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28240f52",
  null
  
)

export default component.exports